import './Legal.css';

export default function Privacy() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last updated: December 2024</p>

                <section>
                    <h2>Information We Collect</h2>
                    <p>autopsyURL collects the following information when you use our service:</p>
                    <ul>
                        <li><strong>URLs you scan</strong> - The web addresses you submit for analysis</li>
                        <li><strong>Scan results</strong> - Screenshots, network data, and diagnostic information</li>
                        <li><strong>Usage data</strong> - How you interact with our service</li>
                    </ul>
                </section>

                <section>
                    <h2>How We Use Your Information</h2>
                    <p>We use collected information to:</p>
                    <ul>
                        <li>Perform website scans and generate diagnostic reports</li>
                        <li>Improve our scanning technology and user experience</li>
                        <li>Maintain and secure our service</li>
                    </ul>
                </section>

                <section>
                    <h2>Data Retention</h2>
                    <p>Scan data is retained for 30 days unless you delete it earlier. You can delete your scan sessions at any time from the Sessions page.</p>
                </section>

                <section>
                    <h2>Data Security</h2>
                    <p>We implement industry-standard security measures to protect your data, including encrypted connections (HTTPS) and secure server infrastructure.</p>
                </section>

                <section>
                    <h2>Third-Party Services</h2>
                    <p>We may use third-party services for analytics and infrastructure. These services have their own privacy policies.</p>
                </section>

                <section>
                    <h2>Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your scan data</li>
                        <li>Delete your scan data</li>
                        <li>Request a copy of your data</li>
                    </ul>
                </section>

                <section>
                    <h2>Contact</h2>
                    <p>For privacy-related questions, contact us at privacy@autopsyurl.com</p>
                </section>
            </div>
        </div>
    );
}
